import React from "react";
import { TrendingUp, TrendingDown, Minus } from "lucide-react";

export const MetricCard = ({ 
  value, 
  label, 
  className = "", 
  icon, 
  format = "number",
  accent = "green"
}) => {
  const formatValue = (val) => {
    if (format === "currency") {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(val);
    }
    if (format === "percentage") {
      return `${val}%`;
    }
    // Format large numbers with K/M suffixes
    if (val >= 1000000) {
      return `${(val / 1000000).toFixed(1)}M`;
    }
    if (val >= 1000) {
      return `${(val / 1000).toFixed(1)}K`;
    }
    return val?.toString() || '0';
  };

  const getAccentColor = () => {
    switch (accent) {
      case "emerald":
        return {
          gradient: "from-emerald-500 to-green-600",
          light: "bg-emerald-50",
          border: "border-emerald-200"
        };
      case "green":
      default:
        return {
          gradient: "from-green-500 to-emerald-600",
          light: "bg-green-50",
          border: "border-green-200"
        };
    }
  };

  const accentColors = getAccentColor();

  return (
    <div className={`bg-white rounded-2xl p-6 border ${accentColors.border} shadow-lg hover:shadow-xl transition-all duration-300 ${className}`}>
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <h3 className="text-lg font-semibold text-gray-900">{label}</h3>
          {icon && <div className="relative z-10">{icon}</div>}
        </div>
      </div>
      
      <div className="flex items-end justify-between">
        <div className={`text-3xl font-bold bg-gradient-to-r ${accentColors.gradient} bg-clip-text text-transparent`}>
          {formatValue(value)}
        </div>
      </div>
      
      {/* Progress indicator
      <div className="mt-4">
        <div className="w-full h-2 bg-gray-100 rounded-full overflow-hidden">
          <div 
            className={`h-full rounded-full bg-gradient-to-r ${accentColors.gradient} transition-all duration-1000`}
            style={{ 
              width: `${Math.min(100, (value / 1000000) * 100)}%` 
            }}
          />
        </div>
      </div> */}
    </div>
  );
};